export default __webpack_public_path__ + "static/media/no-results.2d2c6ee3.png";